/**
 * Data Table component runtime terms
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const dataTable = {
	items: {
		label: "component:dataTable.items#label"
	},
	export: {
		label: "component:dataTable.export#label"
	}
};
